import type { CartData } from '../use-cart'

const EMPTY_CART_ATTEMPTS = 10
const EMPTY_CART_DELAY_MS = 200

let cartSnapshotAfterEmpty: CartData | undefined

export const consumeCartSnapshotAfterEmpty = (): CartData | undefined => {
    const snapshot = cartSnapshotAfterEmpty
    cartSnapshotAfterEmpty = undefined
    return snapshot
}

const sleep = (ms: number): Promise<void> =>
    new Promise((resolve) => setTimeout(resolve, ms))

export const waitUntilCartIsEmpty = async (
    revalidate: () => Promise<CartData | undefined>
): Promise<boolean> => {
    for (let attempt = 0; attempt < EMPTY_CART_ATTEMPTS; attempt++) {
        const latest = await revalidate()
        const items = latest?.data?.cart?.items
        if (
            latest?.data?.cart &&
            Array.isArray(items) &&
            items.filter(Boolean).length === 0
        ) {
            cartSnapshotAfterEmpty = latest
            return true
        }
        await sleep(EMPTY_CART_DELAY_MS)
    }
    return false
}
